import { useEffect } from 'react';

export const useEscapeKey = (
  isActive: boolean,
  onEscape: () => void,
  disabled: boolean = false,
) => {
  useEffect(() => {
    if (!isActive || disabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onEscape();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isActive, onEscape, disabled]);
};
